/**
 * Created by neo on 04.01.17.
 */

import Config from '../Config/index';
import BackendFactory from "../Services/BackendFactory";

class PaymentService {
    stripeApiKey = null;

    constructor() {
    }

    async getPaymentIntent(amount, currency) {
        try {
            var backend = await BackendFactory();
            
            var response = await backend.post('payment-intent', {
                amount: amount, // Backend will convert to cents
                currency: currency.toLowerCase(),
            });
            
            if (response.ok && response.data.success) {
                return response.data;
            } else {
                const errorMessage = response.data && response.data.error ? response.data.error : 'Failed to create payment intent';
                throw new Error(errorMessage);
            }
        } catch (error) {
            console.error('Failed to create payment intent:', error);
            throw new Error(`Failed to create payment intent: ${error.message}`);
        }
    }

    async getPaymentIntentForBooking(booking) {
        try {
            if (!booking) {
                throw new Error('Booking is required');
            }
            
            const amount = booking.getPriceToPay();
            const currency = booking.currency;
            
            if (!amount || amount <= 0) {
                throw new Error('Invalid amount');
            }
            
            if (!currency) {
                throw new Error('Currency is required');
            }

            // Try booking-specific endpoint first if booking has ID/UUID
            if (booking.id || booking.uuid) {
                try {
                    var backend = await BackendFactory();
                    var response = await backend.post('payment-intent/booking', {
                        booking_id: booking.uuid || booking.id,
                    });

                    if (response.ok && response.data.success) {
                        return response.data;
                    }
                } catch (bookingError) {
                    console.warn('Booking-specific endpoint failed, falling back to generic:', bookingError);
                }
            }
            
            // Fallback to generic payment intent
            return await this.getPaymentIntent(amount, currency);
            
        } catch (error) {
            console.error('getPaymentIntentForBooking error:', error);
            throw error;
        }
    }

    async confirmPaymentIntent(paymentIntentId, paymentMethodId) {
        try {
            var backend = await BackendFactory();
            var response = await backend.post('payment-intent/confirm', {
                payment_intent_id: paymentIntentId,
                payment_method_id: paymentMethodId
            });

            if (response.ok && response.data.success) {
                return response.data;
            } else {
                const errorMessage = response.data && response.data.error ? response.data.error : 'Failed to confirm payment intent';
                throw new Error(errorMessage);
            }
        } catch (error) {
            console.error('Failed to confirm payment intent:', error);
            throw error;
        }
    }

    async handleSuccessfulPayment(paymentIntentId, bookingId = null, voucherId = null) {
        try {
            // Build payload with only valid values
            const payload = {
                payment_intent_id: paymentIntentId
            };
            
            if (bookingId) {
                payload.booking_id = bookingId;
            }
            
            if (voucherId) {
                payload.voucher_id = voucherId;
            }
            
            var backend = await BackendFactory();
            var response = await backend.post('payment/success', payload);

            if (response.ok && response.data.success) {
                return response.data;
            } else {
                const errorMessage = response.data && response.data.error ? response.data.error : 'Failed to process successful payment';
                throw new Error(errorMessage);
            }
        } catch (error) {
            console.error('Failed to handle successful payment:', error);
            throw error;
        }
    }

    async getPaymentIntentStatus(paymentIntentId) {
        try {
            var backend = await BackendFactory();
            var response = await backend.get('payment-intent/status', {
                payment_intent_id: paymentIntentId
            });

            if (response.ok && response.data.success) {
                return response.data;
            } else {
                const errorMessage = response.data && response.data.error ? response.data.error : 'Failed to get payment status';
                throw new Error(errorMessage);
            }
        } catch (error) {
            console.error('Failed to get payment intent status:', error);
            throw error;
        }
    }
}

const instance = new PaymentService();
export default instance;



// WEBPACK FOOTER //
// ./src/App/Services/PaymentService.js